import { useLang } from "@/i18n/LanguageContext";

const tones = ["bg-mint", "bg-coral", "bg-butter", "bg-lavender"];

const HowItWorks = () => {
  const { t } = useLang();
  return (
    <section className="py-24 md:py-32 bg-background">
      <div className="container">
        <div className="max-w-3xl">
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-extrabold leading-[1.05]">{t.how.title}</h2>
          <p className="mt-5 text-lg md:text-xl text-muted-foreground">{t.how.subtitle}</p>
        </div>
        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.how.steps.map((s, i) => (
            <div key={s.t} className="relative">
              <div className={`h-16 w-16 rounded-2xl ${tones[i]} flex items-center justify-center text-2xl font-extrabold`}>
                {i + 1}
              </div>
              <h3 className="mt-6 text-xl font-extrabold leading-tight">{s.t}</h3>
              <p className="mt-2 text-base text-muted-foreground leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
